module.exports = __webpack_public_path__ + "img/Hernan-Ferraro-byn.5c133228.jpg";